import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';

import { IconDirective } from '@coreui/icons-angular';
import { SessionModalComponent } from '../../session-modal.component';
import { AuthService } from '../../services/auth.service';
import {PLAN_TYPES} from '../../shared/constants'
import {
  ContainerComponent,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective
} from '@coreui/angular';

import { DefaultFooterComponent, DefaultHeaderComponent } from './';
import { navItems } from './_nav';

function isOverflown(element: HTMLElement) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarBrandComponent,
    RouterLink,
    IconDirective,
    NgScrollbar,
    SidebarNavComponent,
    SidebarFooterComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    DefaultHeaderComponent,
    ShadowOnScrollDirective,
    ContainerComponent,
    RouterOutlet,
    DefaultFooterComponent,
    SessionModalComponent
  ]
})
export class DefaultLayoutComponent implements AfterViewInit {
  public navItems = navItems;
  @ViewChild('sessionModal') sessionModal!: SessionModalComponent;
  constructor(public authService: AuthService) {}

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.authService.startTokenMonitor();
    }
    const isProductOwner = this.authService.isProductOwnerAccess();
    const planType  = this.authService.getCompanyPlan();
    const PlanStatus  = this.authService.getCompanyPlanStatus();
    this.navItems = navItems.filter(item => {
      if(isProductOwner || (this.authService.hasPermission(item.permission) && !item.isforPOOnly 
        && !(planType == PLAN_TYPES.BASIC && item.hideForBasicPlan)
        && !(planType === PLAN_TYPES.PRO && item.hideForProPlan)))
      {
        return true;
      }
      return false;
      
    });
  }

  ngAfterViewInit(): void {
    this.authService.setModalTrigger(() => {
      this.sessionModal.show();
    });
  }

  handleModalRefresh(): void {
    this.authService.refreshToken();
  }
  onScrollbarUpdate($event: any) {
    // if ($event.verticalUsed) {
    // console.log('verticalUsed', $event.verticalUsed);
    // }
  }

  
}
